import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Protocolos } from 'src/app/shared/interfaces/pqfl.type';

@Component({
  selector: 'nz-card-listagem-protocolos',
  standalone: true,
  imports: [CommonModule, NzCardModule, MatExpansionModule, AngularSvgIconModule, NzToolTipModule],
  template: `
    <nz-card class="flex flex-col gap-[10px] py-[20px] px-[10px] dark:bg-white/10 dark:text-white/[.87] dark:border-white/10 rounded-[12px] " nzXs="24" nzMd="12" nzXXl="12">

      <h2 class="mb-[10px] text-xl font-semibold leading-normal text-dark dark:text-white/[.87]"> Protocolos </h2>

      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let item of lista"
          class="border-1"
          (opened)="item.expanded = true"
          (closed)="item.expanded = false">
     <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="flex justify-between w-full items-center font-Poppins gap-3">

          <p class="w-[200px] md:w-full 4xl:w-full"
            [ngClass]="{'truncate': !item.expanded}">
            {{ item.nome }}
          </p>

          <div class="flex items-center gap-3">

            <!-- Abrir protocolo -->
            <svg-icon
              *ngIf="item.urlProtocolo"
              loading="lazy"
              alt="Abrir protocolo"
              nz-tooltip="Abrir protocolo"
              src="assets/images/svg/new-page.svg"
              class="w-4 h-4 [&>svg]:w-full [&>svg]:h-full hover:cursor-pointer opacity-70 hover:opacity-100 transition"
              (click)="abrirProtocolo($event, item)">
            </svg-icon>
          </div>

        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
            <p class="font-Poppins text-light">{{item.descricao}}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </nz-card>
  `,
  styles: [`

        :host ::ng-deep .mat-expansion-panel {
          box-shadow: none !important;
        }

    `],
})

export class CardListagemProtocoloscomponent implements OnInit {
  panelOpenState: boolean = false;
  @Input('lista') lista: Protocolos[] = [];

  constructor(
    private router: Router
  ) { }

 ngOnInit(): void {}

  abrirProtocolo(event: MouseEvent, protocolo: Protocolos) {
    event.stopPropagation();

    if (protocolo.urlProtocolo) {
      this.router.navigate([protocolo.urlProtocolo]);
    }
  }
}
